import { WidgetDefinition } from '../models/WidgetDefinition';

export const alarmsGaugesWidgetDefinition: WidgetDefinition = {
    baseType: 'AlarmsGauges',
    group: 'Charts',
    hasImage: true,
    highlights: ['Gauges with percentage of identifiers in alarm by severity'],
    icon: 'fa-dashboard',
    sortingOrder: 2000,
    title: 'Alarm gauges',
    type: 'AlarmsGauges'
};